import { cn } from '@page/ui';

import { createMarkdownElementRenderer } from '../MarkdownComponentsWithHighlights';

const MarkdownAnchorBase = createMarkdownElementRenderer('a') as (
  props: React.ComponentProps<'a'>,
) => React.ReactElement;

/** Default markdown links — blue + underline (callers may override via `components.a`). */
export const MarkdownAnchorRenderer = ({ className, href, target, rel, ...props }: React.ComponentProps<'a'>) => {
  const isExternal = href?.startsWith('http://') || href?.startsWith('https://');

  return (
    <MarkdownAnchorBase
      {...props}
      href={href}
      target={target ?? (isExternal ? '_blank' : undefined)}
      rel={rel ?? (isExternal ? 'noopener noreferrer' : undefined)}
      className={cn(
        'text-blue-6 underline underline-offset-2 transition-colors duration-150 ease-in-out hover:text-blue-5',
        'dark:text-white dark:decoration-white/50',
        className,
      )}
    />
  );
};
